import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, Typography, Paper } from '@mui/material';
import { useAuth } from '../../context/AuthContext';

const RoleBasedRoute = ({ children, allowedRoles = [] }) => {
  const { user, role, isLoading } = useAuth();
  const location = useLocation();

  // Show loading while authentication is being checked
  if (isLoading) {
    return (
      <Box 
        display="flex" 
        justifyContent="center" 
        alignItems="center" 
        minHeight="400px"
      >
        <Typography>Loading...</Typography>
      </Box>
    );
  }

  // If not authenticated, redirect to login
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Normalize role from Auth0 (handle both "Administrator" and "admin")
  const normalizedRole = role?.toLowerCase() === 'administrator' ? 'admin' : role?.toLowerCase();



  // Check if user has required role
  const hasRequiredRole = allowedRoles.length === 0 || allowedRoles.includes(normalizedRole);

  if (!hasRequiredRole) {
    return (
      <Box 
        display="flex" 
        justifyContent="center" 
        alignItems="center" 
        minHeight="400px"
        p={3}
      >
        <Paper elevation={3} sx={{ p: 4, maxWidth: 500, textAlign: 'center' }}>
          <Typography variant="h5" color="error" gutterBottom>
            Access Denied
          </Typography>
          <Typography variant="body1" color="textSecondary">
            You don't have permission to access this page.
          </Typography>
          <Typography variant="body2" color="textSecondary" sx={{ mt: 2 }}>
            Your role: <strong>{role}</strong>
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Required roles: <strong>{allowedRoles.join(', ')}</strong>
          </Typography>
        </Paper>
      </Box>
    );
  }

  // User has required role, render the protected content
  return children;
};

export default RoleBasedRoute; 